
 <b-icon-circle-fill class="dumpling" font-scale="0.8"
    :class="'color_risk_' + level" 
    v-b-tooltip.hover
    :title="title"
>
</b-icon-circle-fill>
